import React, { Component } from 'react';

import './Tenancy.css';

class Tenancy extends Component {

  handleOnChange = async () => {
    const { live } = this.props;

    this.props.onTenancyChange(!live);
  }

  render() {
    const { live, touchable } = this.props;

    const classNameTest = 'switch-text test ' + (live ? 'unchecked' : 'checked');
    const classNameLive = 'switch-text live ' + (live ? 'checked' : 'unchecked');

    return (
      <>
        <span className={ classNameTest } htmlFor="">TEST</span>
        { touchable !== false && (
          <label className="switch_box" onClick={ this.handleOnChange }>
            <input className="switch" type="checkbox" name="tenancy-switch" checked={ live || false } onChange={ window.noop } />
          </label>
        )}
        { touchable === false && (
          <label className="switch_box">
            <span className="switch-blocked">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </label>
        )}
        <span className={ classNameLive } htmlFor="">LIVE</span>
      </>
    )
  }
}

export default Tenancy;